/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDealerDetailsBioModalLazy_seller = {
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDealerDetailsBioModal_seller">;
    readonly " $refType": "PdpSharedDealerDetailsBioModalLazy_seller";
};
export type PdpSharedDealerDetailsBioModalLazy_seller$data = PdpSharedDealerDetailsBioModalLazy_seller;
export type PdpSharedDealerDetailsBioModalLazy_seller$key = {
    readonly " $data"?: PdpSharedDealerDetailsBioModalLazy_seller$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDealerDetailsBioModalLazy_seller">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedDealerDetailsBioModalLazy_seller",
  "type": "Seller",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDealerDetailsBioModal_seller",
      "args": null
    }
  ]
};
(node as any).hash = '25e812ab7f981a7d66f81a23e8415151';
export default node;
